import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgLargeClock = function SvgLargeClock(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 69 69",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 34.008c0-14.138 11.462-25.6 25.6-25.6 14.133.015 25.585 11.468 25.6 25.6 0 14.139-11.461 25.6-25.6 25.6-14.138 0-25.6-11.461-25.6-25.6zm33.68 11.27c.875.778 2.21.72 3.014-.132v.002a2.133 2.133 0 00-.141-3.016l-9.886-9.063V22.275a2.133 2.133 0 00-4.267 0v11.733c.003.6.257 1.17.7 1.572l10.58 9.699z",
    clipRule: "evenodd"
  }));
};

export default SvgLargeClock;